import {
  type ValidationArguments,
  ValidatorConstraint,
  type ValidatorConstraintInterface,
} from 'class-validator';

/**
 * Check if input string is a valid date.
 * ISO string is preferred but anything that can be converted to a date goes.
 */
@ValidatorConstraint({ name: 'stringDate', async: false })
export class IsStringDate implements ValidatorConstraintInterface {
  validate(dateString: string, args: ValidationArguments) {
    return !Number.isNaN(Date.parse(dateString));
  }

  defaultMessage(args: ValidationArguments) {
    return 'The parsed value ($value) is not a valid date';
  }
}
